// extracted by mini-css-extract-plugin
module.exports =  {"distance":"_93444fe79c--distance--Ls0Vv","icon":"_93444fe79c--icon--HX30U"};